import { render, staticRenderFns } from "./PhysicalExam.vue?vue&type=template&id=e6de7572&scoped=true"
import script from "./PhysicalExam.vue?vue&type=script&lang=js"
export * from "./PhysicalExam.vue?vue&type=script&lang=js"
import style0 from "./PhysicalExam.vue?vue&type=style&index=0&id=e6de7572&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6de7572",
  null
  
)

export default component.exports